import { useState, useEffect } from "react";
import "./SharePointSitePicker.css";
import Modal from "../shared/Modal";
import { MSDrive, MSSite } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { apiGetSharePointSites } from "../../services/DriveService";

type SharePointSitePickerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelected: (mssite: MSSite, msdrive: MSDrive | null) => void;
};

export const SharePointSitePicker = ({
  isOpen,
  onClose,
  onSelected,
}: SharePointSitePickerProps) => {
  const storeUser = useSelector(selectUser);

  const [sharePointSites, setSharePointSites] = useState<MSSite[] | null>(null);

  useEffect(() => {
    if (!sharePointSites && storeUser) {
      (async () => {
        const sites = await apiGetSharePointSites(storeUser.id);
        setSharePointSites(sites);
      })();
    }
  }, []);

  console.log("[SharePointSitesPicker] sites: ", sharePointSites);

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={false}
      allowClickout={true}>
      <div className="sharepoint-site-picker-container">
        {!sharePointSites && (
          <div className="sharepoint-sites-loading">
            <div className="sharepoint-site-picker-logo">
              <img src="/icons/sharepoint.png" alt="" />
            </div>
            Loading SharePoint sites...
          </div>
        )}
        {sharePointSites && (
          <div className="sharepoint-site-picker-header">
            <div className="sharepoint-site-picker-title">
              Pick a SharePoint Site and Resource Type
            </div>
            <div className="sharepoint-site-picker-buttons">
              <img className="icon-close" onClick={onClose} />
            </div>
          </div>
        )}

        <div className="sharepoint-site-picker-body">
          {sharePointSites &&
            sharePointSites.map((mssite: MSSite) => {
              return (
                <>
                  <div
                    key={"sp-site-" + mssite.id}
                    className="sharepoint-site-picker-site">
                    <div className="sharepoint-site-picker-sharepoint">
                      <img src="/icons/sharepoint.png" />
                    </div>
                    <div className="sharepoint-site-picker-site-name">
                      {mssite.name}
                    </div>
                  </div>
                  {mssite.drives &&
                    mssite.drives.map((drive: MSDrive) => {
                      return (
                        <div
                          key={"sp-drive-" + drive.id}
                          className="sharepoint-site-picker-drive"
                          onClick={() => onSelected(mssite, drive)}>
                          <div className="sharepoint-site-picker-folder">
                            <img src="/icons/folder.svg" />
                          </div>
                          <div className="sharepoint-site-picker-site-drive-name">
                            {drive.name}
                          </div>
                        </div>
                      );
                    })}
                  {mssite.pages && mssite.pages.length > 0 && (
                    <div
                      key={"sp-pages-" + mssite.id}
                      className="sharepoint-site-picker-pages"
                      onClick={() => onSelected(mssite, null)}>
                      <div className="sharepoint-site-picker-pages-icon">
                        <img src="/icons/pages.svg" />
                      </div>
                      <div className="sharepoint-site-picker-site-pages-name">
                        Pages ({mssite.pages.length})
                      </div>
                    </div>
                  )}
                </>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};
